export const QUERY_KEYS = {
  // PLAYLISTS
  GET_PLAYLISTS: "playlists",
  GET_PLAYLISTS_BY_SHOW: "playlistsByShow",
  CREATE_PLAYLIST: "createPlaylist",
  GET_PLAYLIST_TRACKS: "playlistTracks",
  GET_PLAYLIST_DETAILS: "playlistDetails",
  UPDATE_PLAYLIST_ACTION: "updatePlaylistAction",
  UPDATE_PLAYLIST_STATUS: "updatePlaylistStatus",
  SUBMIT_PLAYLIST: "submitPlaylist",
  UPDATE_PLAYLIST_TRACK_ORDER_ACTION: "updatePlaylistTrackOrderAction",
  REMOVE_TRACK_FROM_PLAYLIST_ACTION: "removeTrackFromPlaylistAction",

  // Playlist Categories
  GET_PLAYLIST_CATEGORIES: "playlistCategories",

  // Jingles
  GET_JINGLES: "jingles",
  GET_SHOW_JINGLE: "showJingle",
  UPDATE_PLAYLIST_JINGLE: "updatePlaylistJingle",

  // CURATORS
  GET_ALL_CURATORS: "getAllCurators",
  GET_CURATOR_MEDIA: "curatorMedia",
  SUBCURATORS: "subcurators",
  CURATORS_FOR_DROPDOWN: "curatorsForDropdown",
  CREATE_GUEST_CURATOR: "createGuestCurator",
  UPDATE_GUEST_CURATOR: "updateGuestCurator",
  ACTIVE_CURATORS: "activeCurators",
  ARCHIVED_PLAYLIST_COUNT: "archivedPlaylistCount",
  SUBMITTED_PLAYLIST_COUNT: "submittedPlaylistCount",

  // TRACKS / LIBRARY
  GET_TRACKS: "tracks",
  CREATE_TRACK: "createTrack",
  ADD_TRACK_TO_PLAYLIST: "addTrackToPlaylist",
  UPLOAD_TRACK_FILE: "uploadTrackFile",
  UPDATE_TRACK: "updateTrack",
  INFINITE_TRACKS: "infiniteTracks",
  UNTAGGED_TRACKS: "untaggedTracks",
  TRACK_AUDIO: "trackAudio",
  TRACK_SHAZAM_INFO: "trackShazamInfo",
  EXTRACT_AUDIO_METADATA: "extractAudioMetadata",

  // SCHEDULE
  GET_SCHEDULE: "schedule",
  GET_MASTER_SCHEDULE: "masterSchedule",
  GET_SCHEDULE_BOARD: "scheduleBoard",
  GET_SUBMITTED_PLAYLISTS_BY_SHOW: "submittedPlaylistsByShow",

  // SHOWS
  GET_SHOW: "show",
  GET_MY_SHOWS: "getMyShows",
  GET_SHOW_DETAILS: "showDetails",
  GET_CURATOR_SHOW_PROMOS: "curatorShowPromos",

  // TAGS
  GET_TAGS: "tags",
  CREATE_TAG: "createTag",
  DELETE_TAG: "deleteTag",
  UPDATE_TAG: "updateTag",

  GET_GENRES_TAGS: "genresTags",
  CREATE_GENRE_TAG: "createGenreTag",
  DELETE_GENRE_TAG: "deleteGenreTag",
  UPDATE_GENRE_TAG: "updateGenreTag",

  GET_FEELING_TAGS: "feelingTags",
  CREATE_FEELING_TAG: "createFeelingTag",
  DELETE_FEELING_TAG: "deleteFeelingTag",
  UPDATE_FEELING_TAG: "updateFeelingTag",

  // MOODS
  GET_MOODS: "moods",
  GET_MOOD_FACTORY_DETAILS: "moodFactoryDetails",

  // GET VINYLS
  GET_VINYLS: "vinyls",
  GET_SELECTED_VINYLS: "selectedVinyls",
  // PLAYLIST RECOMMENDATION TAGS
  GET_PLAYLIST_RECOMMENDATION_TAGS: "playlistRecommendationTags",
  CREATE_PLAYLIST_RECOMMENDATION_TAG: "createPlaylistRecommendationTag",

  // ARTICLES
  GET_ARTICLES: "articles",
  CREATE_ARTICLE: "createArticle",

  // STATUS CHECK
  TICKET_STATUS_COUNTS: "ticketStatusCounts",

  // ADMIN MESSAGES (read-only view of every curator conversation)
  ADMIN_CONVERSATIONS: "adminConversations",
  ADMIN_CONVERSATION_HISTORY: "adminConversationHistory",

  // MANAGER CONFIGURATION (what a manager may do on the dashboard)
  MANAGER_CONFIGURATION: "managerConfiguration",
};
